(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('CompendiumReportGroupSearch', CompendiumReportGroupSearch);

    CompendiumReportGroupSearch.$inject = ['$resource'];

    function CompendiumReportGroupSearch($resource) {
        var resourceUrl =  'api/_search/compendium-report-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
